module.exports = __webpack_public_path__ + "static/media/compare.9aa14922.svg";